import { Case } from "./types";

export const industries: Case[] = [
  {
    identifier: "apparel-and-footwear",
    title: "Apparel and Footwear",
  },
  {
    identifier: "automotive-parts",
    title: "Automotive Parts",
  },
  {
    identifier: "book-stores",
    title: "Book Stores",
  },
  {
    identifier: "consumer-electronics",
    title: "Consumer Electronics",
  },
  {
    identifier: "fashion",
    title: "Fashion",
  },
  {
    identifier: "general-merchandise-department-stores",
    title: "General Merchandise/ Department Stores",
  },
  {
    identifier: "grocery",
    title: "Grocery",
  },
  {
    identifier: "health-beauty-personal-care",
    title: "Health, Beauty and Personal Care",
  },
  {
    identifier: "home-living",
    title: "Home & Living",
  },
  {
    identifier: "jewelry-watches",
    title: "Jewelry & Watches",
  },
  {
    identifier: "luxury-goods",
    title: "Luxury Goods",
  },
  {
    identifier: "musical-instruments",
    title: "Musical Instruments",
  },
  {
    identifier: "office-supplies-stationery-gifts",
    title: "Office Supplies, Stationery, and Gifts",
  },
  {
    identifier: "optical-goods",
    title: "Optical Goods",
  },
  {
    identifier: "pet-pet-supplies",
    title: "Pet and Pet Supplies",
  },
  {
    identifier: "sporting-goods-hobby",
    title: "Sporting Goods and Hobby",
  },
  {
    identifier: "toys-games",
    title: "Toys and Games",
  },
  {
    identifier: "whole-sale",
    title: "Whole Sale",
  },
];
